import styled from "styled-components";

export const Section = styled.section`
  width: 100%;
  min-height: 90vh;
  background: rgba(255, 244, 230, 0.467);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5rem 6%;
  margin-bottom: 4.5rem;

  @media (max-width: 800px) {
    margin-bottom: 3rem;
  }
`;

export const Container = styled.div`
  max-width: 1300px;
  width: 100%;
  display: flex;
  gap: 3.5rem;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Right = styled.div`
  flex: 1.3;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  color: rgb(107, 79, 79);
  font-size: 3.2rem;
  margin-bottom: 1rem;
  line-height: 1.05;

  span {
    color: rgba(244, 167, 185, 1);
  }
`;

export const Description = styled.p`
  color: rgb(107, 79, 79);
  line-height: 1.7;
  margin-bottom: 1.6rem;
  max-width: 520px;
`;

export const Button = styled.a`
  padding: 0.8rem 1.8rem;
  background: linear-gradient(90deg, rgba(255, 138, 128, 1), rgba(244, 167, 185, 1));
  color: #fff4e6;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 700;
  box-shadow: 0 8px 24px rgba(244, 167, 185, 0.18);
  border: 1px solid rgba(244, 167, 185, 0.22);

  &:hover {
    transform: translateY(-3px);
  }
`;

export const ImageSlider = styled.div`
  position: relative;
  width: 100%;
  max-width: 920px;
  height: 540px;
  overflow: hidden;
  border-radius: 18px;
  background: linear-gradient(180deg, #fff, #fff6f8);
  box-shadow: 0 18px 40px rgba(244, 167, 185, 0.12);
`;

export const Track = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  transition: transform 0.6s cubic-bezier(0.2, 0.9, 0.3, 1);
  will-change: transform;
`;

export const Slide = styled.div`
  position: relative;
  min-width: 100%;
  height: 100%;
  transition:
    transform 0.6s cubic-bezier(0.2, 0.9, 0.3, 1),
    opacity 0.5s ease,
    filter 0.5s ease;
  will-change: transform, opacity, filter;

  &.active {
    animation: kenburns 10s ease-in-out infinite alternate;
    box-shadow: 0 16px 40px rgba(244, 167, 185, 0.16);
    border-radius: 14px;
    overflow: hidden;
  }

  @keyframes kenburns {
    from {
      transform: scale(1) translateY(0);
    }
    to {
      transform: scale(1.04) translateY(-8px);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ThumbStrip = styled.div`
  position: absolute;
  left: 0;
  bottom: 12px;
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 6px 12px;
`;

export const Thumb = styled.img`
  width: 72px;
  height: 52px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid transparent;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;

  &:hover {
    transform: translateY(-6px) scale(1.02);
  }

  &.active {
    box-shadow: 0 10px 30px rgba(244, 167, 185, 0.18);
    border-color: rgba(255, 138, 128, 1);
    transform: translateY(-8px) scale(1.06);
  }
`;

export const NavButton = styled.button`
  position: absolute;
  top: 50%;
  ${(props) => (props.left ? "left: 8px;" : "right: 8px;")}
  transform: translateY(-50%);
  background: linear-gradient(180deg, rgba(255, 214, 221, 0.9), rgba(255, 196, 202, 0.9));
  border: none;
  color: #6b4f4f;
  font-size: 1.3rem;
  padding: 0.4rem 0.9rem;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(244, 167, 185, 0.12);
`;

export const Dots = styled.div`
  position: absolute;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => (props.active ? "rgba(255,138,128,1)" : "rgba(107,79,79,0.12)")};
  cursor: pointer;
`;
